import { render, staticRenderFns } from "./AppDrawerToggleButton.vue?vue&type=template&id=2b64f2db&"
import script from "./AppDrawerToggleButton.vue?vue&type=script&lang=js&"
export * from "./AppDrawerToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports